export const entityHasId = (entity, id) => isEntity(entity) && entity.id === id;

export const getRelId = (entity, relationshipName) => {
  const rel = getRel(entity, relationshipName);
  return rel && rel.data ? rel.data.id : null;
};

export const getRelIds = (entity, relationshipName) => {
  const rel = getRel(entity, relationshipName);
  return rel && rel.data ? getRelIdsFromData(rel.data) : null;
};

const getRelIdsFromData = (data) => {
  const dataIds = [];
  data.forEach((x) => dataIds.push(x.id));
  return dataIds;
};

export const getRelIdsOfType = (entity, relType) =>
  isEntity(entity)
    ? Object.values(entity.relationships)
        .filter((rel) => rel?.data?.type === relType)
        .map((rel) => rel.data.id)
    : [];

export const getRel = (entity, relationshipName) =>
  isEntity(entity) && entity.relationships[relationshipName];

export const relIsPresent = (entity, relationshipName) =>
  !!getRel(entity, relationshipName);

export const relHasReference = (entity, relationshipName) =>
  getRelId(entity, relationshipName) != null;

export const relHasId = (entity, relationshipName, id) =>
  getRelId(entity, relationshipName) === id;

export const getEntityId = (entity) =>
  isEntity(entity) ? entity.id : undefined;

export const isEntity = (entity, warnIfNot = false) => {
  const result = !!entity && !!entity.type;
  if (!result && warnIfNot) {
    console.warn('Object is not an entity!', entity);
  }
  return result;
};

export const relRefersToEntity = (relEntity, relationshipName, refEntity) => {
  const rel = getRel(relEntity, relationshipName);
  return (
    rel &&
    rel.data &&
    isEntity(refEntity) &&
    rel.data.type === refEntity.type &&
    rel.data.id === getEntityId(refEntity)
  );
};

export const getAttr = (entity, attrName) =>
  isEntity(entity) && entity.attributes[attrName];

export const getAttrByIdFromArrayOfObjects = (entity, attrName, id) =>
  entity.find((x) => x.id === id).attributes[attrName];

export const getEntityType = (entity) => isEntity(entity) && entity.type;

export const hasAttr = (entity, attrName) =>
  isEntity(entity) && attrName in entity.attributes;
